// extracted by mini-css-extract-plugin
export default {"personalDataWrapper":"css_personalDataWrapper__dOlnj","section":"css_section__zNb3O"};